module.exports = __webpack_public_path__ + "img/新闻资讯_07.08d926ad.png";